(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kieu-ads-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kieu-ads-dialog')) {
    customElements.define('kieu-ads-dialog', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        document.addEventListener('click', (event) => {
          const link = event.target.closest('[data-kieu-enquiry-open], [data-kieu-booking-trigger], a[href="#treatment-enquiry"]');
          if (!link || link.getAttribute('href')?.startsWith('tel:') || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.opener = link;
          if (this.hasAttribute('data-inline-form') && !this.dialog.querySelector('kieu-ads-form')) {
            this.home = document.querySelector('[data-enquiry-inline]');
            const form = this.home?.querySelector('kieu-ads-form');
            if (!form) return;
            this.homeMinHeight = this.home.style.minHeight;
            this.home.style.minHeight = `${this.home.getBoundingClientRect().height}px`;
            this.dialog.append(form);
          }
          const select = this.dialog.querySelector('select[name="treatment"]');
          if (select && link.dataset.enquiryTreatment) {
            select.value = link.dataset.enquiryTreatment;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (!this.dialog.open) this.dialog.showModal();
        }, options);
        this.querySelector('[data-enquiry-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.restoreForm();
          this.opener?.focus({ preventScroll: true });
        }, options);
      }
      restoreForm() {
        if (!this.home) return;
        const form = this.dialog.querySelector('kieu-ads-form');
        if (form) this.home.append(form);
        this.home.style.minHeight = this.homeMinHeight;
      }
      disconnectedCallback() { this.controller?.abort(); this.restoreForm(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kieu-ads-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kieu-ads-form')) {
    customElements.define('kieu-ads-form', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('form');
        this.button = this.querySelector('[type="submit"]');
        this.buttonLabel = this.button.innerHTML;
        this.error = this.querySelector('[data-enquiry-error]');
        this.storageKey = 'kieu-ads-confirmed:' + location.pathname + ':' + this.form.elements.source_funnel.value;
        let confirmedAt = 0;
        try { confirmedAt = Number(sessionStorage.getItem(this.storageKey)); } catch (_) {}
        if (new URL(location.href).searchParams.get('success') === '1' && confirmedAt > 0 && confirmedAt <= Date.now() && Date.now() - confirmedAt < 1800000) this.showSuccess();
        this.button.disabled = !this.dataset.endpoint;
        this.form.addEventListener('submit', (event) => this.submit(event));
        this.form.querySelector('[type="tel"]').addEventListener('input', (event) => event.target.setCustomValidity(''));
      }
      showSuccess() {
        this.form.hidden = true;
        this.querySelector('[data-enquiry-intro]').hidden = true;
        const success = this.querySelector('[data-enquiry-success]');
        success.hidden = false;
        if (this.dataset.profile !== 'fm01') document.title = this.dataset.successTitle + ' – Dr. Kieu';
        requestAnimationFrame(() => {
          const dialog = this.closest('dialog');
          if (dialog && !dialog.open) dialog.showModal();
          success.focus();
        });
      }
      prepareLeadMeasurement() {
        if (!this.dataset.ga4MeasurementId) return;
        try { window.KieuBookingGA4?.prepareLead({ measurementId: this.dataset.ga4MeasurementId }); } catch (_) {}
      }
      async sendLeadEvent() {
        if (this.leadEventSent) return;
        this.leadEventSent = true;
        if (!this.dataset.ga4MeasurementId) return;
        try { await window.KieuBookingGA4?.sendLead({ measurementId: this.dataset.ga4MeasurementId }); } catch (_) {}
      }
      attributionAllowed() {
        try {
          const privacy = window.Shopify?.customerPrivacy;
          const consent = privacy?.currentVisitorConsent?.();
          return consent?.analytics === 'yes' && consent?.marketing === 'yes' &&
            privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true;
        } catch (_) { return false; }
      }
      campaignParameters() {
        if (!this.attributionAllowed()) return {};
        const query = new URL(location.href).searchParams;
        const parameters = {};
        const names = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
          'gclid', 'gbraid', 'wbraid', 'hsa_cam', 'hsa_grp', 'hsa_mt', 'hsa_src', 'hsa_ad',
          'hsa_acc', 'hsa_net', 'hsa_kw', 'hsa_tgt', 'hsa_ver'];
        for (const name of names) {
          const value = query.get(name);
          if (!value || value.length > 256 || /[\x00-\x1f\x7f<>@]/.test(value)) continue;
          if (['gclid', 'gbraid', 'wbraid'].includes(name) && !/^[A-Za-z0-9_-]+$/.test(value)) continue;
          parameters[name] = value;
        }
        return parameters;
      }
      sourcePageUri(fields) {
        if (!/^\/pages\/[a-z0-9-]+$/.test(fields.source_path)) throw new Error('Invalid source page');
        const url = new URL('https://drkieu.de' + fields.source_path);
        // Retain a matching alternate template, never arbitrary or preview query data.
        if (new URL(location.href).searchParams.get('view') === fields.source_funnel) {
          url.searchParams.set('view', fields.source_funnel);
        }
        for (const [name, value] of Object.entries(this.campaignParameters())) url.searchParams.set(name, value);
        return url.href;
      }
      hubSpotContext(fields, pageName) {
        const context = { pageName, pageUri: this.sourcePageUri(fields) };
        if (this.attributionAllowed()) {
          // Use only an existing HubSpot visitor cookie; never manufacture an identity.
          const hutk = document.cookie.match(/(?:^|;\s*)hubspotutk=([a-f0-9]{32})(?:;|$)/i)?.[1];
          if (hutk) context.hutk = hutk;
        }
        return context;
      }
      campaignFields() {
        const parameters = this.campaignParameters();
        const mapping = { utm_source: 'utm_source_utm_source', utm_medium: 'utm_medium_utm_medium',
          utm_campaign: 'utm_campaign_utm_campaign', utm_content: 'utm_content', utm_term: 'utm_term',
          gclid: 'kieu_gclid' };
        const fields = Object.entries(mapping).filter(([name]) => parameters[name]).map(([name, property]) =>
          ({ objectTypeId: '0-1', name: property, value: parameters[name] }));
        if (parameters.gclid) fields.push({ objectTypeId: '0-1', name: 'kieu_gclid_quelle', value: 'google-ads-form-url' });
        return fields;
      }
      fm01Payload(fields) {
        const endpoint = 'https://api.hsforms.com/submissions/v3/integration/submit/148413109/87f245d5-46e3-40df-8c8f-fb67d0b83637';
        if (this.dataset.endpoint !== endpoint || fields.consent !== true ||
            fields.consent_version !== 'fm01-beratung-2026-09-16' || fields.company_website ||
            fields.source_funnel !== 'website-fm01' || fields.therapie_interesse !== 'FM-01') throw new Error('Invalid enquiry');
        const insurance = new Map([['private', 'I001'], ['statutory', 'I002'], ['self_pay', 'I002']]);
        if (!insurance.has(fields.insurance)) throw new Error('Invalid insurance');
        for (const name of ['firstname', 'lastname', 'email', 'phone']) {
          if (typeof fields[name] !== 'string' || !fields[name].trim()) throw new Error('Missing field');
        }
        const field = (name, value) => ({ objectTypeId: '0-1', name, value });
        return {
          submittedAt: String(Date.now()),
          fields: [field('firstname', fields.firstname.trim()), field('lastname', fields.lastname.trim()),
            field('email', fields.email.trim()), field('phone', fields.phone.trim()), field('therapie_interesse', 'FM-01'),
            field('kieu_a01', insurance.get(fields.insurance)), ...this.callbackFields(fields)],
          context: this.hubSpotContext(fields, 'kieu Beratungsanfrage FM-01'),
          legalConsentOptions: { consent: { consentToProcess: true, text: this.form.elements.consent.value, communications: [] } }
        };
      }
      hubSpotPayload(fields) {
        const insurance = new Map([['private', 'I001'], ['statutory', 'I002'], ['self_pay', 'I002']]);
        const treatments = new Set(['checkup', 'akufloating', 'hbot', 'hoehenlufttraining', 'infusionen', 'skin-longevity', 'orientation']);
        const pages = new Map([
          ['ads-brand', ['uber-uns', 'ads-kieu']], ['ads-about-us', ['uber-uns', 'ads-about-us']],
          ['ads-kieu360', ['kieu360', 'ads-kieu360']], ['ads-akufloating', ['akufloating', 'ads-akufloating']],
          ['ads-hbot', ['hbot', 'ads-hbot']], ['ads-hoehenlufttraining', ['hoehenlufttraining', 'ads-hoehenlufttraining']],
          ['ads-infusionen', ['infusionen', 'ads-infusionen']], ['ads-skin-longevity', ['skin-longevity', 'ads-skin-longevity']]
        ]);
        if (!insurance.has(fields.insurance) || !treatments.has(fields.treatment) || fields.consent !== true ||
            fields.consent_version !== 'ads-enquiry-2026-09-13' || fields.company_website ||
            !pages.get(fields.source_funnel)?.some(handle => fields.source_path === '/pages/' + handle)) throw new Error('Invalid enquiry');
        const field = (name, value) => ({ objectTypeId: '0-1', name, value });
        return {
          submittedAt: String(Date.now()),
          fields: [field('firstname', fields.firstname), field('lastname', fields.lastname), field('email', fields.email.trim()),
            field('telefonnummer_eingegeben_bitte_um_anruf', fields.phone), field('therapie_interesse', fields.treatment),
            field('kieu_a01', insurance.get(fields.insurance)), field('funnel__perspective', 'google-ads-form'), ...this.campaignFields(), ...this.callbackFields(fields)],
          context: this.hubSpotContext(fields, 'kieu Gesprächsanfrage | ' + fields.source_funnel),
          legalConsentOptions: { consent: { consentToProcess: true, text: this.form.elements.consent.value, communications: [] } }
        };
      }
      callbackFields(fields) {
        const value = fields.callback_preference;
        if (!['9:00 - 12:00', '12:00 - 15:00', '15:00 - 18:00'].includes(value)) throw new Error('Choose a callback time');
        return [{ objectTypeId: '0-1', name: 'beste_erreichbarkeit__perspective', value }];
      }
      showReview() {
        let status = this.form.querySelector('[data-cro-review-result]');
        if (!status) {
          status = document.createElement('p');
          status.dataset.croReviewResult = '';
          status.className = 'dk-enquiry__qualification';
          status.setAttribute('role', 'status');
          status.tabIndex = -1;
          this.button.after(status);
        }
        const preference = this.form.elements.callback_preference?.value || '';
        status.textContent = 'Vorschau geprüft. Rückrufwunsch: ' + preference + '. Es wurde keine Anfrage versendet.';
        status.focus();
      }
      async submit(event) {
        event.preventDefault();
        if (this.busy || !this.dataset.endpoint) return;
        const phone = this.form.querySelector('[type="tel"]');
        phone.setCustomValidity(/^[+0-9() /.-]{7,30}$/.test(phone.value) && phone.value.replace(/\D/g, '').length >= 7 ? '' : phone.labels[0].textContent);
        for (const input of this.form.querySelectorAll('input[type="text"]')) input.value = input.value.trim();
        if (!this.form.reportValidity()) return;
        if (this.dataset.croReview === 'true') {
          this.showReview();
          return;
        }
        this.busy = true;
        this.button.disabled = true;
        this.button.textContent = this.dataset.busy;
        this.error.hidden = true;
        this.prepareLeadMeasurement();
        this.requestId ||= crypto.randomUUID();
        const fields = Object.fromEntries(new FormData(this.form));
        fields.consent = this.form.elements.consent.checked;
        fields.request_id = this.requestId;
        try {
          const fm01 = this.dataset.profile === 'fm01';
          const direct = fm01 || this.dataset.endpoint === 'https://api.hsforms.com/submissions/v3/integration/submit/148413109/212c1e2b-a111-42bb-af1a-e2bcef30d058';
          const payload = fm01 ? this.fm01Payload(fields) : direct ? this.hubSpotPayload(fields) : fields;
          const response = await fetch(this.dataset.endpoint, {
            method: 'POST', mode: 'cors', credentials: 'omit', referrerPolicy: 'no-referrer', redirect: 'error',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload), signal: AbortSignal.timeout(20000)
          });
          const result = await response.json();
          const accepted = direct ? response.status === 200 && result && !result.errors && (typeof result.inlineMessage === 'string' || typeof result.redirectUri === 'string') : response.ok && result.accepted === true && result.request_id === this.requestId;
          if (!accepted) throw new Error('Unconfirmed');
          await this.sendLeadEvent();
          try { sessionStorage.setItem(this.storageKey, String(Date.now())); } catch (_) {}
          if (fm01) { this.form.reset(); this.showSuccess(); return; }
          const url = new URL(location.href);
          const preview = url.searchParams.get('preview_theme_id');
          const view = url.searchParams.get('view');
          const clickIds = ['gclid', 'gbraid', 'wbraid']
            .map(name => [name, url.searchParams.get(name)])
            .filter(([, value]) => value && value.length <= 256 && /^[A-Za-z0-9_-]+$/.test(value));
          const linker = url.searchParams.get('_gl');
          url.search = '';
          if (preview) url.searchParams.set('preview_theme_id', preview);
          if (view) url.searchParams.set('view', view);
          for (const [name, value] of clickIds) url.searchParams.set(name, value);
          if (linker && linker.length <= 2048 && /^[A-Za-z0-9_*.-]+$/.test(linker)) url.searchParams.set('_gl', linker);
          url.searchParams.set('success', '1');
          url.hash = 'treatment-enquiry';
          this.form.reset();
          this.showSuccess();
          location.assign(url);
        } catch (_) {
          this.error.textContent = this.dataset.error;
          this.error.hidden = false;
          this.error.focus();
        } finally {
          this.busy = false;
          this.button.disabled = false;
          this.button.innerHTML = this.buttonLabel;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
